const formatItinerariesFromCruiseOption = ({ travelOptions }) => (travelOptions
  && travelOptions
    .map((o) => o.itineraryRows && o.itineraryRows.map((r) => ({
      ...r,
      cruiseLine: o.cruiseLine,
      itineraryTitle: o.itineraryTitle,
      ship: o.ship,
      itineraryPortsOfCall: o.itineraryPortsOfCall,
      travelOption: o,
      tripId: o.key,
    })))
    .flat()) || [];

export default formatItinerariesFromCruiseOption;
